import { Link } from "react-router-dom";
import { Reveal, ImageReveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { CAPABILITIES, IMAGES } from "../lib/site";

export default function Capabilities() {
    return (
        <div data-testid="page-capabilities" className="pt-32">
            <Seo
                title="Capabilities — From Volumes to Bespoke"
                description="White-label and private-label linen manufacturer in India. Hospitality bedding supplier, hotel linen partner, OEM bedsheet and bath linen maker — from grand volumes to bespoke touches, delivered with exacting precision."
                path="/capabilities"
            />
            <section className="container-vyom pb-16 md:pb-24">
                <Reveal>
                    <div className="text-[17.5px] uppercase tracking-overline text-vyom-mute mb-8">
                        Capabilities
                    </div>
                </Reveal>
                <Reveal delay={0.05}>
                    <h1 className="font-serif-display text-5xl md:text-7xl lg:text-[104px] leading-[0.98] tracking-tight max-w-5xl">
                        From{" "}
                        <span className="italic">grand volumes</span> to
                        bespoke touches.
                    </h1>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mt-10 max-w-xl text-[20px] leading-[1.8] text-vyom-mute">
                        A boutique studio with the depth of a heritage mill —
                        every order is calibrated to your house, every detail
                        delivered with exacting precision.
                    </p>
                </Reveal>
            </section>

            <section className="border-y border-vyom-rule">
                <ImageReveal
                    src={IMAGES.weave}
                    alt="Weave detail in natural light"
                    className="aspect-[16/9] md:aspect-[21/9]"
                />
            </section>

            <section className="container-vyom section-pad">
                <div className="grid grid-cols-1 md:grid-cols-2">
                    {CAPABILITIES.map((c, i) => (
                        <Reveal key={c.index} delay={(i % 2) * 0.1}>
                            <div
                                data-testid={`capability-row-${c.index}`}
                                className={`p-8 md:p-12 lg:p-16 border-vyom-rule border-t ${
                                    i % 2 === 0 ? "md:border-r" : ""
                                }`}
                            >
                                <div className="font-serif-display italic text-vyom-mute text-[22px] mb-8">
                                    — {c.index}
                                </div>
                                <h3 className="font-serif-display text-3xl md:text-4xl leading-tight tracking-tight">
                                    {c.title}
                                </h3>
                                <p className="mt-6 text-[19.5px] leading-[1.85] text-vyom-mute max-w-md">
                                    {c.copy}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="border-t border-vyom-rule">
                <div className="container-vyom section-pad text-center">
                    <Reveal>
                        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight max-w-3xl mx-auto">
                            Tell us the order. We will hold the standard.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="mt-10 inline-flex">
                            <Link
                                to="/contact"
                                data-testid="capabilities-cta"
                                className="text-[19px] whitespace-nowrap uppercase tracking-overline border border-vyom-ink px-8 py-3.5 text-vyom-ink hover:bg-vyom-ink hover:text-vyom-bg transition-colors duration-500"
                            >
                                Begin a conversation
                            </Link>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
